import { ProjectInfo } from './project.model';

export type User = {
  id?: number;
  email: string;
  user_details: {
    title: string;
    salutation: string;
    first_name: string | null;
    last_name: string | null;
  };
  roles?: Role[];
  projects: ProjectInfo[];
};

export type UserForm = Omit<User, 'roles'> & {
  projects: ProjectInfo[];
  roles: number[];
};

export type Role = {
  id: number;
  name: string;
  label: string;
};

export type TimeLog = {
  totalWorkSeconds: number;
  project_location: string;
  project: string;
  totalWorkHr: string;
};

export const titles = [
  {
    title: 'Dr.',
  },
  {
    title: 'Prof.',
  },
];

export const salutations = [
  {
    salutation: 'Herr',
  },
  {
    salutation: 'Frau',
  },
];
